<template>
	<div class="Social">
		<p v-text="message"></p>
	</div>
</template>

<script>
	export default {
		name: "SocialGitlabLogin",
		data: ()=>{
			return {
				message: '正在处理，请稍后...',
			};
		},
		created(){
			let code = this.$route.query.code;
			if(code === undefined || code === ''){
				this.$Notice.error({
					title: '登陆失败，参数无效',
				});
				this.$router.push({name: "Login"});
				return;
			}

			this.$fetch.social.gitlab_login({code}).then(data=>{
				if(data.user === null){
					this.$router.push({
						name: 'SocialGithubRegister', params: {
							user_social: data.user_social,
						}
					});
					return;
				}

				this.$store.commit('SetUser', {user: data.user, expire_in: data.token.expires_in});
				this.$store.commit('SetToken', {token: data.token, expire_in: data.token.expires_in});
				this.$router.push({name: "Index_index"});
			});
		}
	}
</script>

<style scoped lang="less">

</style>